
import React, { useContext, Children, useEffect } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from 'react-router-dom'
import Button from '../formfields/Button'
import Spinner from '../ui-elements/Spinner'
import { findDefaultDate } from '../utils/findDefaultDate'



type Props = {
  questionId?: string
  checklistId?: string
  setQuestionAnswer: React.Dispatch<React.SetStateAction<any>>
  defaultValue: null | string | string[]
}

function QuestionDateAndTime({
  questionId,
  checklistId,
  setQuestionAnswer,
  defaultValue
}: Props) {

  const {
    tableData
  } = useContext(GlobalContext)

  const thisQuestion = questionId && tableData && tableData['ChecklistQuestions'] && tableData['ChecklistQuestions'][questionId]
  const dateOptions = thisQuestion.DateOptions
  const todaysDate = new Date()
  const formattedDate = `${todaysDate.getFullYear()}-${String(todaysDate.getMonth() + 1).padStart(2, '0')}-${String(todaysDate.getDate()).padStart(2, '0')}T00:00`

  useEffect(() => {
    if (thisQuestion && setQuestionAnswer) {
      findDefaultDate(thisQuestion, setQuestionAnswer, true)
    }
  }, [thisQuestion, setQuestionAnswer])



  return <div className={`w-full flex flex-row gap-2 items-center`}>


    <input
      className={`bg-white text-center drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full text-lg px-5 py-3`}
      onChange={(e) => setQuestionAnswer(e.target.value)}
      type={`datetime-local`}
      min={dateOptions && dateOptions === 'Future' ? formattedDate : undefined}
      max={dateOptions && dateOptions === 'Past' ? formattedDate : undefined}
      value={defaultValue || ''}
    />



    {thisQuestion && thisQuestion.MeasurementUnit && <p>{thisQuestion.MeasurementUnit}</p>}

  </div>
}

export default QuestionDateAndTime
